import React from 'react';
import IconPng from '../components/IconPng';

const ICONS = [
  'Cpu',
  'Database',
  'ChartLineUp',
  'Lightbulb',
  'CurrencyCircleDollar',
  'ChartBar',
  'Minus',
  'Target',
  'Envelope',
  'Plus',
  'Phone',
  'MapPin',
  'CodeBlock',
  'Globe',
  'TreeStructure',
  'Eye',
  'PuzzlePiece',
  'PushPin',
];

export default function IconsShowcase() {
  return (
    <div className="icons-grid">
      {ICONS.map((name) => (
        <div key={name} className="icon-tile">
          <IconPng name={name} size={28} />
          <div className="icon-name">{name}</div>
        </div>
      ))}
    </div>
  );
}

